export default __webpack_public_path__ + "static/media/seongdonggu-seongsudong-hallasigmavalley-2.82b16ebe.jpg";